package org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.update_template_category


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class UpdateTemplateCategoryModel(
    @SerialName("data")
    val  data : Data?,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)